import React, { createContext, useContext, useState, useEffect } from 'react';
import { getSiteSettings } from '../api/api';

const SiteSettingsContext = createContext();

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    showBuyNow: true,
    showExploreMaterial: true,
    showBrowseMaterials: true,
    portalUrl: "https://hline-consumer.vercel.app"
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await getSiteSettings();
        if (data) {
          setSettings(data);
        }
      } catch (err) {
        console.error("Failed to fetch site settings", err);
      }
    };
    fetchSettings();
  }, []);

  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (context === undefined) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return context;
};
